export default {
  getConfig: {
    zh_cn: '查询设备参数',
    en: 'Query Device Parameters',
    zhhant: '查詢設備參數',
    he: 'שאל פרמטרים מכשיר',
    de: 'Geräteparameter abfragen',
    es: 'Consultar parámetros del dispositivo',
    ru: 'Запросить параметры устройства',
    vi: 'Truy vấn thông số thiết bị',
  },
  getConfigDesc: {
    zh_cn: '获取设备配置参数, 参数格式是yaml格式。参数信息请咨询设备服务商。',
    en: 'Get device configuration parameters. The parameter format is YAML. Please consult the device service provider for parameter information.',
    zhhant: '獲取設備配置參數, 參數格式是yaml格式。參數信息請諮詢設備服務商。',
    he: 'קבל פרמטרים של קונפיגורציה של המכשיר. הפורמט של הפרמטרים הוא YAML. אנא התייעץ עם ספק השירות של המכשיר לקבלת מידע על הפרמטרים.',
    de: 'Holen Sie sich die Gerätekonfigurationsparameter. Das Parameterformat ist YAML. Bitte wenden Sie sich an den Geräteanbieter, um Parameterinformationen zu erhalten.',
    es: 'Obtenga los parámetros de configuración del dispositivo. El formato de los parámetros es YAML. Consulte al proveedor del servicio del dispositivo para obtener información sobre los parámetros.',
    ru: 'Получите параметры конфигурации устройства. Формат параметров - YAML. Пожалуйста, проконсультируйтесь с поставщиком услуг устройства для получения информации о параметрах.',
    vi: 'Lấy các thông số cấu hình thiết bị. Định dạng thông số là YAML. Vui lòng tham khảo nhà cung cấp dịch vụ thiết bị để biết thông tin về thông số.',
  },
  setConfigDesc: {
    zh_cn: '修改设备配置参数, 参数格式是yaml格式。参数信息请咨询设备服务商。',
    en: 'Modify device configuration parameters. The parameter format is YAML. Please consult the device service provider for parameter information.',
    zhhant: '修改設備配置參數, 參數格式是yaml格式。參數信息請諮詢設備服務商。',
    he: 'שנה פרמטרים של קונפיגורציה של המכשיר. הפורמט של הפרמטרים הוא YAML. אנא התייעץ עם ספק השירות של המכשיר לקבלת מידע על הפרמטרים.',
    de: 'Ändern Sie die Gerätekonfigurationsparameter. Das Parameterformat ist YAML. Bitte wenden Sie sich an den Geräteanbieter, um Parameterinformationen zu erhalten.',
    es: 'Modifique los parámetros de configuración del dispositivo. El formato de los parámetros es YAML. Consulte al proveedor del servicio del dispositivo para obtener información sobre los parámetros.',
    ru: 'Измените параметры конфигурации устройства. Формат параметров - YAML. Пожалуйста, проконсультируйтесь с поставщиком услуг устройства для получения информации о параметрах.',
    vi: 'Sửa đổi các thông số cấu hình thiết bị. Định dạng thông số là YAML. Vui lòng tham khảo nhà cung cấp dịch vụ thiết bị để biết thông tin về thông số.',
  },
  evseTricelessOTA: {
    zh_cn: '无痕升级',
    en: 'Triceless OTA',
    zhhant: '無痕升級',
    he: 'אפס מכשיר',
    de: 'Gerät zurücksetzen',
    es: 'Restablecer dispositivo',
    ru: 'Сброс устройства',
    vi: 'Đặt lại thiết bị',
  },
  evseReset: {
    zh_cn: '设备复位',
    en: 'Device Reset',
    zhhant: '設備重啟',
    he: 'אפס מכשיר',
    de: 'Gerät zurücksetzen',
    es: 'Restablecer dispositivo',
    ru: 'Сброс устройства',
    vi: 'Đặt lại thiết bị',
  },
  evseReboot: {
    zh_cn: '设备重启',
    en: 'Device Reboot',
    zhhant: '設備重啟',
    he: 'פעלה מחדש מכשיר',
    de: 'Gerät neu starten',
    es: 'Reiniciar dispositivo',
    ru: 'Перезагрузка устройства',
    vi: 'Đặt lại thiết bị',
  },
  sendQrcode: {
    zh_cn: '下发二维码',
    zhhant: '下發二維碼',
    en: 'Send QRcode',
    he: 'שלח קוד QR',
    de: 'QR-Code senden',
    es: 'Enviar código QR',
    ru: 'Отправить QR-код',
    vi: 'Gửi mã QR',
  },
  sendPricing: {
    zh_cn: '下发计费策略',
    zhhant: '下發計費策略',
    en: 'Send Pricing Policy',
    he: 'שלח מדיה לכרטיס',
    de: 'Preisrichtlinie senden',
    es: 'Enviar política de precios',
    ru: 'Отправить ценовую политику',
    vi: 'Gửi chính sách giá cả',
  },
  evseClearCache: {
    zh_cn: '清除设备缓存',
    en: 'Clear Device Cache',
    zhhant: '清除設備緩存',
    he: 'נקה מטמון של המכשיר',
    de: 'Geräte-Cache löschen',
    es: 'Borrar caché del dispositivo',
    ru: 'Очистить кэш устройства',
    vi: 'Xóa bộ nhớ đệm thiết bị',
  },
  evseClearProflie: {
    zh_cn: '清除设备配置',
    en: 'Clear Device Profile',
    zhhant: '清除設備配置',
    he: 'נקה פרופיל מכשיר',
    de: 'Geräteprofil löschen',
    es: 'Borrar perfil del dispositivo',
    ru: 'Очистить профиль устройства',
    vi: 'Xóa hồ sơ thiết bị',
  },
  evseOp: {
    zh_cn: '设备常用操作',
    en: 'Device Common Operation',
    zhhant: '設備常用操作',
    he: 'פעולות כלליות של מכשיר',
    de: 'Geräte-Allgemeine Operationen',
    es: 'Operaciones comunes del dispositivo',
    ru: 'Общие операции устройства',
    vi: 'Thao tác chung thiết bị',
  },
  setConfig: {
    zh_cn: '修改设备参数',
    en: 'Change Device Config',
    zhhant: '修改設備配置參數',
    he: 'שנה פרמטרים של קונפיגורציה של המכשיר',
    de: 'Ändern Sie die Gerätekonfigurationsparameter',
    es: 'Cambiar parámetros de configuración del dispositivo',
    ru: 'Изменить параметры конфигурации устройства',
    vi: 'Sửa đổi các thông số cấu hình thiết bị',
  },
  addEvseTip: {
    zh_cn:
      '如果需要批量添加设备时，请使用逗号","分隔多个设备编号，请确认编号没有被使用。例如: 20240101,20240102',
    zhhant:
      '如果需要批量添加設備時，請使用逗號","分隔多個設備編號，請確認編號沒有被使用。例如: 20240101,20240102',
    en: 'If you need to add devices in batches, please separate multiple device numbers with commas ",". Please confirm that the number is not used. For example: 20240101,20240102',
    he: 'אם יש לך צורך בכך להוסיף מכשירים במקדם, אנא שדרוג את מספרים המכשירים עם פסיקים ",". אנא בדוק שהמספר לא נעשה שימוש. לדוגמה: 20240101,20240102',
    de: 'Wenn Sie mehrere Geräte gleichzeitig hinzufügen müssen, trennen Sie die Gerätenummern mit Kommas ",". Bitte best ätzen Sie, dass die Nummer nicht verwendet wird. Beispiel: 20240101,20240102',
    es: 'Si necesita agregar dispositivos en lote, sepárelos con comas ",". Confirme que el número no está en uso. Por ejemplo: 20240101,20240102',
    ru: 'Если вам необходимо добавить устройства в пакетном режиме, разделите их запятыми ",". Проверьте, что номер не используется. Пример: 20240101,20240102',
    vi: 'Nếu bạn cần thêm nhiều thiết bị cùng lúc, vui lòng phân tách số điện thoại bằng dấu phẩy ",". Vui lòng kiểm tra rằng số không được sử dụng. Ví dụ: 20240101,20240102',
  },
  deleteEvseConfirm: {
    zh_cn: '确认删除该设备？',
    zhhant: '確認刪除該設備？',
    en: 'Confirm to delete this device?',
    he: 'האם אתה בטוח שאתה רוצה למחוק מכשיר זה?',
    de: 'Möchten Sie dieses Gerät wirklich löschen?',
    es: '¿Confirma que desea eliminar este dispositivo?',
    ru: 'Вы уверены, что хотите удалить это устройство?',
    vi: 'Bạn có chắc chắn muốn xóa thiết bị này không?',
  },
  addEvseOTA: {
    zh_cn: '添加设备升级',
    en: 'Add Device Upgrade',
    zhhant: '添加設備升級',
    he: 'הוסף שדרוג מכשיר',
    de: 'Gerät hinzufügen Upgrade',
    es: 'Añadir actualización de dispositivo',
    ru: 'Добавить обновление устройства',
    vi: 'Thêm nâng cấp thiết bị',
  },
  otaRequesting: {
    zh_cn: 'OTA请求中',
    en: 'OTA Requesting',
    zhhant: 'OTA請求中',
    he: 'בקשת OTA מתבצעת',
    de: 'OTA-Anfrage wird ausgeführt',
    es: 'Solicitud de OTA en proceso',
    ru: 'Запрос на обновление выполняется',
    vi: 'Yêu cầu OTA đang được thực hiện',
  },
  otaRequestOK: {
    zh_cn: 'OTA请求成功',
    en: 'OTA Request OK',
    zhhant: 'OTA請求成功',
    he: 'בקשת OTA תקינה',
    de: 'OTA-Anfrage OK',
    es: 'Solicitud de OTA correcta',
    ru: 'Запрос на обновление успешно выполнен',
    vi: 'Yêu cầu OTA thành công',
  },
  otaRequestFail: {
    zh_cn: 'OTA请求失败',
    en: 'OTA Request Fail',
    zhhant: 'OTA請求失敗',
    he: 'בקשת OTA נכשלה',
    de: 'OTA-Anfrage fehlgeschlagen',
    es: 'Solicitud de OTA fallida',
    ru: 'Запрос на обновление не выполнен',
    vi: 'Yêu cầu OTA không thành công',
  },
  otaProcessing: {
    zh_cn: 'OTA处理中',
    en: 'OTA Processing',
    zhhant: 'OTA處理中',
    he: 'תהליך OTA מתבצע',
    de: 'OTA-Verarbeitung wird ausgeführt',
    es: 'Procesando la solicitud de OTA',
    ru: 'Обновление выполняется',
    vi: 'Quá trình OTA đang được thực hiện',
  },
  otaProcessFails: {
    zh_cn: 'OTA处理失败',
    en: 'OTA Process Fail',
    zhhant: 'OTA處理失敗',
    he: 'תהליך OTA נכשל',
    de: 'OTA-Verarbeitung fehlgeschlagen',
    es: 'Proceso de OTA fallido',
    ru: 'Обновление не выполнено',
    vi: 'Quá trình OTA không thành công',
  },
  otaOK: {
    zh_cn: 'OTA成功',
    en: 'OTA OK',
    zhhant: 'OTA成功',
    he: 'OTA תקינה',
    de: 'OTA OK',
    es: 'OTA correcta',
    ru: 'Обновление выполнено',
    vi: 'OTA thành công',
  },
  otaFail: {
    zh_cn: 'OTA失败',
    en: 'OTA Fail',
    zhhant: 'OTA失敗',
    he: 'OTA נכשלה',
    de: 'OTA fehlgeschlagen',
    es: 'OTA fallida',
    ru: 'Обновление не выполнено',
    vi: 'OTA không thành công',
  },
  fromVersion: {
    zh_cn: '原版本',
    en: 'From Version',
    zhhant: '原版本',
    he: 'מגרסה',
    de: 'Von Version',
    es: 'Desde la versión',
    ru: 'С версии',
    vi: 'Từ Phiên Bản',
  },
  toVersion: {
    zh_cn: '目标版本',
    en: 'To Version',
    zhhant: '目標版本',
    he: 'לגרסה',
    de: 'Zu Version',
    es: 'A la versión',
    ru: 'До версии',
    vi: 'Đến Phiên Bản',
  },
  id: {
    zh_cn: 'ID',
    en: 'ID',
    zhhant: 'ID',
    he: 'מזהה',
    de: 'ID',
    es: 'ID',
    ru: 'ID',
    vi: 'ID',
  },
  sn: {
    zh_cn: '设备编号',
    en: 'Serial Number',
    zhhant: '設備編號',
    he: 'מספר סידורי',
    de: 'Seriennummer',
    es: 'Número de serie',
    ru: 'Серийный номер',
    vi: 'Số sê-ri',
  },
  evseSN: {
    zh_cn: '设备编号',
    en: 'Serial Number',
    zhhant: '設備編號',
    he: 'מספר סידורי',
    de: 'Seriennummer',
    es: 'Número de serie',
    ru: 'Серийный номер',
    vi: 'Số sê-ri',
  },
  equipment: {
    zh_cn: '设备',
    en: 'Equipment',
    zhhant: '設備',
    he: 'ציוד',
    de: 'Ausrüstung',
    es: 'Equipo',
    ru: 'Оборудование',
    vi: 'Thiết bị',
  },
  name: {
    zh_cn: '设备名称',
    en: 'Alias',
    zhhant: '設備名稱',
    he: 'כינוי',
    de: 'Alias',
    es: 'Alias',
    ru: 'Псевдоним',
    vi: 'Tên',
  },
  cname: {
    en: 'Connector Name',
    zh_cn: '接口名称',
    zhhant: '接口名稱',
    he: 'כינוי מחבר',
    de: 'Name des Connectors',
    es: 'Nombre del conector',
    ru: 'Название разъема',
    vi: 'Tên kết nối',
  },
  evseName: {
    zh_cn: '设备名称',
    en: 'Alias',
    zhhant: '設備名稱',
    he: 'כינוי',
    de: 'Alias',
    es: 'Alias',
    ru: 'Псевдоним',
    vi: 'Tên',
  },
  cno: {
    zh_cn: '枪头',
    en: 'Connector NO',
    zhhant: '槍頭',
    he: 'מספר מחבר',
    de: 'Steckdosen-Nr.',
    es: 'Número de conector',
    ru: 'Номер разъема',
    vi: 'Số kết nối',
  },
  connectorNum: {
    zh_cn: '枪头数量',
    en: 'Connector Number',
    zhhant: '槍頭數量',
    he: 'מספר מחברים',
    de: 'Anzahl der Steckdosen',
    es: 'Número de conectores',
    ru: 'Количество разъемов',
    vi: 'Số lượng kết nối',
  },
  connector: {
    zh_cn: '充电接口',
    en: 'Connectors',
    zhhant: '充電接口',
    he: 'מחברים',
    de: 'Steckdosen',
    es: 'Conectores',
    ru: 'Разъемы',
    vi: 'Kết nối',
  },
  power: {
    zh_cn: '功率',
    en: 'Power',
    zhhant: '功率',
    he: 'הספק',
    de: 'Leistung',
    es: 'Potencia',
    ru: 'Мощность',
    vi: 'Công suất',
  },
  powerW: {
    zh_cn: '功率 (W)',
    en: 'Power (W)',
    zhhant: '功率 (W)',
    he: 'הספק (W)',
    de: 'Leistung (W)',
    es: 'Potencia (W)',
    ru: 'Мощность (Вт)',
    vi: 'Công suất (Vt)',
  },
  order: {
    zh_cn: '充电订单',
    en: 'Charging Order',
    zhhant: '充電訂單',
    he: 'הזמנת טעינה',
    de: 'Ladeauftrag',
    es: 'Orden de carga',
    ru: 'Заказ на зарядку',
    vi: 'Đơn hàng sạc',
  },
  evseType: {
    zh_cn: '设备类型',
    en: 'EVSE Type',
    zhhant: '設備類型',
    he: 'סוג ציוד',
    de: 'Ausrüstungsart',
    es: 'Tipo de EVSE',
    ru: 'Тип оборудования',
    vi: 'Loại thiết bị',
  },
  evseCurrentType: {
    zh_cn: '电流类型',
    en: 'Current Type',
    zhhant: '電流類型',
    he: 'סוג זרם',
    de: 'Stromart',
    es: 'Tipo de corriente',
    ru: 'Тип тока',
    vi: 'Loại dòng điện',
  },
  ratedVoltage: {
    zh_cn: '额定电压',
    en: 'Rated Voltage',
    zhhant: '額定電壓',
    he: 'מתח מדורג',
    de: 'Nennspannung',
    es: 'Voltaje nominal',
    ru: 'Номинальное напряжение',
    vi: 'Điện áp định mức',
  },
  ratedCurrent: {
    zh_cn: '额定电流',
    en: 'Rated Current',
    zhhant: '額定電流',
    he: 'זרם מדורג',
    de: 'Nennstrom',
    es: 'Corriente nominal',
    ru: 'Номинальный ток',
    vi: 'Dòng điện định mức',
  },
  current: {
    zh_cn: '电流',
    en: 'Current',
    zhhant: '電流',
    he: 'זרם',
    de: 'Strom',
    es: 'Corriente',
    ru: 'Ток',
    vi: 'Dòng điện',
  },
  currentA: {
    zh_cn: '电流(A)',
    zhhant: '電流(A)',
    en: 'Current (A)',
    he: 'זרם (A)',
    de: 'Strom (A)',
    es: 'Corriente (A)',
    ru: 'Ток (А)',
    vi: 'Dòng điện (A)',
  },
  voltage: {
    zh_cn: '电压',
    zhhant: '電壓',
    he: 'מדורג',
    de: 'Spannung',
    es: 'Voltaje',
    ru: 'Напряжение',
    vi: 'Điện áp',
  },
  minCurrent: {
    zh_cn: '最小电流',
    en: 'Min Current',
    zhhant: '最小電流',
    he: 'זרם מינימלי',
    de: 'Min. Strom',
    es: 'Corriente mínima',
    ru: 'Минимальный ток',
    vi: 'Dòng điện tối thiểu',
  },
  maxCurrent: {
    zh_cn: '最大电流',
    en: 'Max Current',
    zhhant: '最大電流',
    he: 'זרם מקסימלי',
    de: 'Max. Strom',
    es: 'Corriente máxima',
    ru: 'Максимальный ток',
    vi: 'Dòng điện tối đa',
  },
  maxPower: {
    zh_cn: '最大功率',
    zhhant: '最大功率',
    en: 'Max Power',
    he: 'מקסימלי',
    de: 'Max. Leistung',
    es: 'Potencia máxima',
    ru: 'Максимальная мощность',
    vi: 'Công suất tối đa',
  },
  netType: {
    zh_cn: '网络',
    en: 'Network',
    zhhant: '網絡',
    he: 'רשת',
    de: 'Netzwerk',
    es: 'Red',
    ru: 'Сеть',
    vi: 'Mạng',
  },
  startMode: {
    zh_cn: '授权方式',
    en: 'Authorization Mode',
    zhhant: '授權方式',
    he: 'מצב אישור',
    de: 'Autorisierungsmodus',
    es: 'Modo de autorización',
    ru: 'Режим авторизации',
    vi: 'Chế độ xác thực',
  },
  vendor: {
    zh_cn: '供应商',
    en: 'Vendor',
    zhhant: '供應商',
    he: 'ספק',
    de: 'Anbieter',
    es: 'Proveedor',
    ru: 'Поставщик',
    vi: 'Nhà cung cấp',
  },
  protocol: {
    zh_cn: '协议',
    en: 'Protocol',
    zhhant: '協議',
    he: 'פרוטוקול',
    de: 'Protokoll',
    es: 'Protocolo',
    ru: 'Протокол',
    vi: 'Giao thức',
  },
  version: {
    zh_cn: '版本',
    en: 'Version',
    zhhant: '版本',
    he: 'גרסה',
    de: 'Version',
    es: 'Versión',
    ru: 'Версия',
    vi: 'Phiên bản',
  },
  versionCode: {
    zh_cn: '版本代码',
    en: 'Version Code',
    zhhant: '版本代碼',
    he: 'קוד גרסה',
    de: 'Versionscode',
    es: 'Código de versión',
    ru: 'Код версии',
    vi: 'Mã phiên bản',
  },
  firmwareAddress: {
    zh_cn: '固件地址',
    en: 'Firmware Address',
    zhhant: '固件地址',
    he: 'כתובת קושחה',
    de: 'Firmware-Adresse',
    es: 'Dirección del firmware',
    ru: 'Адрес прошивки',
    vi: 'Địa chỉ firmware',
  },
  protocolVersion: {
    zh_cn: '协议版本',
    en: 'Protocol Version',
    zhhant: '協議版本',
    he: 'גרסת פרוטוקול',
    de: 'Protokollversion',
    es: 'Versión del protocolo',
    ru: 'Версия протокола',
    vi: 'Phiên bản giao thức',
  },
  firmwareVersion: {
    zh_cn: '固件版本',
    en: 'Firmware Version',
    zhhant: '固件版本',
    he: 'גרסת קושחה',
    de: 'Firmware-Version',
    es: 'Versión del firmware',
    ru: 'Версия прошивки',
    vi: 'Phiên bản firmware',
  },
  firmwareVersionCode: {
    zh_cn: '固件版本编码',
    en: 'Firmware Version Code',
    zhhant: '固件版本編碼',
    he: 'קוד גרסת קושחה',
    de: 'Firmware-Versionscode',
    es: 'Código de versión de firmware',
    ru: 'Код версии прошивки',
    vi: 'Mã phiên bản firmware',
  },
  faulted: {
    zh_cn: '故障信息',
    en: 'Faulted Info',
    zhhant: '故障信息',
    he: 'מידע על תקלות',
    de: 'Fehlerinformationen',
    es: 'Información de fallos',
    ru: 'Информация о сбоях',
    vi: 'Thông tin lỗi',
  },
  state: {
    zh_cn: '状态',
    en: 'Status',
    zhhant: '狀態',
    he: 'סטטוס',
    de: 'Status',
    es: 'Estado',
    ru: 'Состояние',
    vi: 'Trạng thái',
  },
  stateOffline: {
    zh_cn: '离线',
    en: 'Offline',
    zhhant: '離線',
    he: 'לא מחובר',
    de: 'Offline',
    es: 'Desconectado',
    ru: 'Офлайн',
    vi: 'Ngoại tuyến',
  },
  stateOnline: {
    zh_cn: '在线',
    en: 'Online',
    zhhant: '在線',
    he: 'מחובר',
    de: 'Online',
    es: 'En línea',
    ru: 'В сети',
    vi: 'Trực tuyến',
  },
  stateException: {
    zh_cn: '异常',
    en: 'Exception',
    zhhant: '異常',
    he: 'חריגה',
    de: 'Ausnahme',
    es: 'Excepción',
    ru: 'Исключение',
    vi: 'Ngoại lệ',
  },
  stateNonactivated: {
    zh_cn: '未激活',
    en: 'Nonactivated',
    zhhant: '未激活',
    he: 'לא מופעל',
    de: 'Nicht aktiviert',
    es: 'No activado',
    ru: 'Не активирован',
    vi: 'Chưa kích hoạt',
  },
  connectorStateUnavailable: {
    zh_cn: '不可用',
    en: 'Unavailable',
    zhhant: '不可用',
    he: 'לא זמין',
    de: 'Nicht verfügbar',
    es: 'No disponible',
    ru: 'Недоступен',
    vi: 'Không khả dụng',
  },
  connectorStateAvailable: {
    zh_cn: '空闲',
    en: 'Available',
    zhhant: '空閒',
    he: 'זמין',
    de: 'Verfügbar',
    es: 'Disponible',
    ru: 'Доступен',
    vi: 'Có sẵn',
  },
  connectorStatePreparing: {
    zh_cn: '已连接',
    en: 'Preparing',
    zhhant: '已連接',
    he: 'מתכונן',
    de: 'Vorbereitung',
    es: 'Preparando',
    ru: 'Подготовка',
    vi: 'Đang chuẩn bị',
  },
  connectorStateCharging: {
    zh_cn: '充电中',
    en: 'Charging',
    zhhant: '充電中',
    he: 'טוען',
    de: 'Laden',
    es: 'Cargando',
    ru: 'Зарядка',
    vi: 'Đang sạc',
  },
  connectorStateSuspendedEVSE: {
    zh_cn: '充电已开启, 充电桩未输出',
    en: 'Suspended EVSE',
    zhhant: '充電已開啟, 充電樁未輸出',
    he: 'EVSE מושעה',
    de: 'EVSE ausgesetzt',
    es: 'EVSE suspendido',
    ru: 'Приостановка EVSE',
    vi: 'EVSE bị treo',
  },
  connectorStateSuspendedEV: {
    zh_cn: '充电已开启, 电动汽车未充电',
    en: 'Suspended EV',
    zhhant: '充電已開啟, 電動汽車未充電',
    he: 'EV מושעה',
    de: 'EV ausgesetzt',
    es: 'EV suspendido',
    ru: 'Приостановка EV',
    vi: 'EV bị treo',
  },
  connectorStateFinishing: {
    zh_cn: '充电完成',
    en: 'Finishing',
    zhhant: '充電完成',
    he: 'סיום',
    de: 'Abschluss',
    es: 'Terminando',
    ru: 'Завершение',
    vi: 'Hoàn thành',
  },
  connectorStateReserved: {
    zh_cn: '预约',
    en: 'Reserved',
    zhhant: '預約',
    he: 'מוזמן',
    de: 'Reserviert',
    es: 'Reservado',
    ru: 'Зарезервировано',
    vi: 'Đã đặt trước',
  },
  connectorStateFaulted: {
    zh_cn: '故障',
    en: 'Faulted',
    zhhant: '故障',
    he: 'תקלה',
    de: 'Fehlerhaft',
    es: 'Con fallo',
    ru: 'Ошибка',
    vi: 'Lỗi',
  },
  connectorWaiting: {
    zh_cn: '等待充电中',
    en: 'Waiting',
    zhhant: '等待充電中',
    he: 'ממתין',
    de: 'Warten',
    es: 'Esperando',
    ru: 'Ожидание',
    vi: 'Đang chờ',
  },
  connectorOccupied: {
    zh_cn: '设备占用中',
    en: 'Occupied',
    zhhant: '設備佔用中',
    he: 'תפוס',
    de: 'Belegt',
    es: 'Ocupado',
    ru: 'Занято',
    vi: 'Đang chiếm dụng',
  },
  model: {
    zh_cn: '设备型号',
    en: 'Evse Model',
    zhhant: '設備型號',
    he: 'דגם',
    de: 'Gerätemodell',
    es: 'Modelo de equipo',
    ru: 'Модель оборудования',
    vi: 'Mẫu thiết bị',
  },
  addEvseModel: {
    zh_cn: '添加设备型号',
    en: 'Add Evse Model',
    zhhant: '添加設備型號',
    he: 'הוסף דגם',
    de: 'Evse Modell hinzufügen',
    es: 'Agregar modelo de equipo',
    ru: 'Добавить модель EVSE',
    vi: 'Thêm mẫu thiết bị',
  },
  editEvseModel: {
    zh_cn: '编辑设备型号',
    en: 'Edit Evse Model',
    zhhant: '編輯設備型號',
    he: 'ערוך דגם',
    de: 'Evse Modell bearbeiten',
    es: 'Editar modelo de equipo',
    ru: 'Редактировать модель EVSE',
    vi: 'Chỉnh sửa mẫu thiết bị',
  },
  product: {
    zh_cn: '设备型号系列',
    en: 'Model Product Line',
    zhhant: '設備型號系列',
    he: 'קו מוצר דגם',
    de: 'Modellproduktlinie',
    es: 'Línea de productos del modelo',
    ru: 'Модельный ряд продуктов',
    vi: 'Dòng sản phẩm mẫu',
  },
  standard: {
    zh_cn: '设备标准',
    en: 'Evse Standard',
    zhhant: '設備標準',
    he: 'תקן',
    de: 'Gerätestandard',
    es: 'Estándar del equipo',
    ru: 'Стандарт EVSE',
    vi: 'Tiêu chuẩn thiết bị',
  },
  phase: {
    zh_cn: '相',
    en: 'Phase',
    zhhant: '相',
    he: 'שלב',
    de: 'Phase',
    es: 'Fase',
    ru: 'Фаза',
    vi: 'Pha',
  },
  useVehicleType: {
    zh_cn: '使用车辆',
    en: 'Use Vehicle Type',
    zhhant: '使用車輛',
    he: 'סוג רכב בשימוש',
    de: 'Verwendeter Fahrzeugtyp',
    es: 'Tipo de vehículo usado',
    ru: 'Тип используемого транспортного средства',
    vi: 'Loại phương tiện sử dụng',
  },
  networking: {
    zh_cn: '联网方式',
    en: 'Device Access Network Mode',
    zhhant: '網絡連接方式',
    he: 'מצב גישת הרשת של המכשיר',
    de: 'Netzwerkzugangsmodus',
    es: 'Modo de acceso a la red del dispositivo',
    ru: 'Режим доступа к сети устройства',
    vi: 'Chế độ truy cập mạng của thiết bị',
  },
  ratedPower: {
    zh_cn: '额定功率',
    en: 'Rated Power',
    zhhant: '額定功率',
    he: 'הספק מדורג',
    de: 'Nennleistung',
    es: 'Potencia nominal',
    ru: 'Номинальная мощность',
    vi: 'Công suất định mức',
  },
  createdAt: {
    zh_cn: '创建时间',
    en: 'Created At',
    zhhant: '創建時間',
    he: 'נוצר ב',
    de: 'Erstellt am',
    es: 'Creado en',
    ru: 'Создано',
    vi: 'Ngày tạo',
  },
  accessIP: {
    zh_cn: '入网IP',
    en: 'Access IP',
    zhhant: '入網IP',
    he: 'כתובת IP גישה',
    de: 'Zugriffs-IP',
    es: 'IP de acceso',
    ru: 'IP для доступа',
    vi: 'IP truy cập',
  },
  temperature: {
    zh_cn: '温度',
    en: 'Temperature',
    zhhant: '溫度',
    he: 'טמפרטורה',
    de: 'Temperatur',
    es: 'Temperatura',
    ru: 'Температура',
    vi: 'Nhiệt độ',
  },
  inputVoltage: {
    zh_cn: '输入电压',
    en: 'Input Voltage',
    zhhant: '輸入電壓',
    he: 'מתח כניסה',
    de: 'Eingangsspannung',
    es: 'Voltaje de entrada',
    ru: 'Входное напряжение',
    vi: 'Điện áp đầu vào',
  },
  workDuration: {
    zh_cn: '工作时间',
    en: 'Work Duration',
    zhhant: '工作時間',
    he: 'משך עבודה',
    de: 'Arbeitsdauer',
    es: 'Duración del trabajo',
    ru: 'Продолжительность работы',
    vi: 'Thời gian làm việc',
  },
  outputVoltage: {
    zh_cn: '输出电压',
    en: 'Output Voltage',
    zhhant: '輸出電壓',
    he: 'מתח פלט',
    de: 'Ausgangsspannung',
    es: 'Voltaje de salida',
    ru: 'Выходное напряжение',
    vi: 'Điện áp đầu ra',
  },
  outputCurrent: {
    zh_cn: '输出电流',
    en: 'Output Current',
    zhhant: '輸出電流',
    he: 'זרם פלט',
    de: 'Ausgangsstrom',
    es: 'Corriente de salida',
    ru: 'Выходной ток',
    vi: 'Dòng điện đầu ra',
  },
  alarmCount: {
    zh_cn: '告警总数',
    en: 'Alarm Count',
    zhhant: '告警總數',
    he: 'ספירת התראות',
    de: 'Alarmanzahl',
    es: 'Número de alarmas',
    ru: 'Количество тревог',
    vi: 'Số lượng cảnh báo',
  },
  alarmActCount: {
    zh_cn: '活跃告警总数',
    en: 'Active Alarm Count',
    zhhant: '活躍告警總數',
    he: 'ספירת התראות פעילה',
    de: 'Anzahl aktiver Alarme',
    es: 'Número de alarmas activas',
    ru: 'Количество активных тревог',
    vi: 'Số lượng cảnh báo hoạt động',
  },
  operatorName: {
    zh_cn: '运营商',
    en: 'Operator',
    zhhant: '運營商',
    he: 'מפעיל',
    de: 'Betrieber',
    es: 'Operador',
    ru: 'Оператор',
    vi: 'Nhà điều hành',
  },
  stationName: {
    zh_cn: '站点名称',
    en: 'Station Name',
    zhhant: '站點名稱',
    he: 'שם תחנה',
    de: 'Stationsname',
    es: 'Nombre de la estación',
    ru: 'Название станции',
    vi: 'Tên trạm',
  },
  firmwareinfo: {
    zh_cn: '固件信息',
    en: 'Firmware Info',
    zhhant: '固件信息',
    he: 'מידע על קושחה',
    de: 'Firmware-Info',
    es: 'Información del firmware',
    ru: 'Информация о прошивке',
    vi: 'Thông tin firmware',
  },
  firmwaresByModel: {
    en: 'Firmware records for the model',
    zh_cn: '型号的固件记录',
    zhhant: '型號的固件記錄',
    he: 'רשומות קושחה לדגם',
    de: 'Firmware-Datensätze für das Modell',
    es: 'Registros de firmware para el modelo',
    ru: 'Записи прошивок для модели',
    vi: 'Bản ghi firmware cho mô hình',
  },
  firmwarelist: {
    zh_cn: '固件列表',
    en: 'Firmware List',
    zhhant: '固件列表',
    he: 'רשימת קושחות',
    de: 'Firmware-Liste',
    es: 'Lista de firmwares',
    ru: 'Список прошивок',
    vi: 'Danh sách firmware',
  },
  firmware: {
    zh_cn: '固件',
    en: 'Firmware',
    zhhant: '固件',
    he: 'קושחה',
    de: 'Firmware',
    es: 'Firmware',
    ru: 'Прошивка',
    vi: 'Firmware',
  },
  addEvse: {
    zh_cn: '创建设备',
    zhhant: '创建設備',
    en: 'Create Charger Equipment',
    he: 'צור מכשיר',
    de: 'Ladegerät erstellen',
    es: 'Crear equipo de carga',
    ru: 'Создать зарядное оборудование',
    vi: 'Tạo thiết bị sạc',
  },
  editEvse: {
    zh_cn: '编辑设备',
    en: 'Edit Charger Equipment',
    zhhant: '編輯設備',
    he: 'ערוך מכשיר',
    de: 'Ladegerät bearbeiten',
    es: 'Editar equipo de carga',
    ru: 'Редактировать зарядное оборудование',
    vi: 'Chỉnh sửa thiết bị sạc',
  },
  batchAddEvse: {
    zh_cn: '批量添加设备',
    en: 'Batch Add Charger Equipment',
    zhhant: '批量添加設備',
    he: 'הוסף מכשירים בקבוצות',
    de: 'Ladegeräte im Batch hinzufügen',
    es: 'Agregar equipos de carga por lotes',
    ru: 'Пакетное добавление зарядных устройств',
    vi: 'Thêm thiết bị sạc theo lô',
  },
  inputEvseModle: {
    zh_cn: '请输入设备型号信息',
    en: 'Please enter the equipment model information',
    zhhant: '請輸入設備型號信息',
    he: 'אנא הזן את פרטי הדגם',
    de: 'Bitte geben Sie die Modellinformationen ein',
    es: 'Por favor ingrese la información del modelo de equipo',
    ru: 'Пожалуйста, введите информацию о модели оборудования',
    vi: 'Vui lòng nhập thông tin mẫu thiết bị',
  },
  selectedEvses: {
    zh_cn: '已选择设备',
    en: 'Selected Equipment',
    zhhant: '已選設備',
    he: 'מכשירים שנבחרו',
    de: 'Ausgewähltes Gerät',
    es: 'Equipo seleccionado',
    ru: 'Выбранное оборудование',
    vi: 'Đã chọn thiết bị',
  },
  confirmRetryEvseOta: {
    zh_cn: '确定重新触发升级 ？',
    en: 'Are you sure to retry the upgrade?',
    zhhant: '確定要重試升級？',
    he: 'האם אתה בטוח שאתה רוצה לנסות עדכון שוב?',
    de: 'Sind Sie sicher, dass Sie das Update erneut versuchen wollen?',
    es: '¿Está seguro de que desea reintentar la actualización?',
    ru: 'Вы уверены, что хотите повторить обновление?',
    vi: 'Xác định kích hoạt lại việc nâng cấp?',
  },
  selectOtaEvses: {
    zh_cn: '选择需要升级的设备',
    en: 'Select the equipment to be upgraded',
    zhhant: '選擇需要升級的設備',
    he: 'בחר מכשירים לעדכון',
    de: 'Wählen Sie das zu aktualisierende Gerät aus',
    es: 'Seleccione el equipo para actualizarlo',
    ru: 'Выберите оборудование для обновления',
    vi: 'Chọn thiết bị cần nâng cấp',
  },
  selectEvseModle: {
    zh_cn: '选择已有的设备型号',
    en: 'Select an existing equipment model',
    zhhant: '選擇已有的設備型號',
    he: 'בחר דגם קיים',
    de: 'Wählen Sie ein vorhandenes Modell',
    es: 'Seleccione un modelo de equipo existente',
    ru: 'Выберите существующую модель оборудования',
    vi: 'Chọn một mẫu thiết bị hiện có',
  },
  operationType: {
    zh_cn: '设备运营类型',
    en: 'Type of equipment operation',
    zhhant: '設備運營類型',
    he: 'סוג הפעלת מכשיר',
    de: 'Gerätebetriebstyp',
    es: 'Tipo de operación del equipo',
    ru: 'Тип эксплуатации оборудования',
    vi: 'Loại hoạt động thiết bị',
  },
  connectorType: {
    zh_cn: '枪头类型',
    en: 'Charging Connector Standard',
    zhhant: '槍頭類型',
    he: 'סוג מחבר',
    de: 'Ladeanschlussstandard',
    es: 'Estándar del conector de carga',
    ru: 'Стандарт разъема для зарядки',
    vi: 'Tiêu chuẩn kết nối sạc',
  },
  evseOperationTypeHome: {
    zh_cn: '家充设备',
    en: 'Household Evse',
    zhhant: '家充設備',
    he: 'EVSE ביתי',
    de: 'Haushalts-EVSE',
    es: 'EVSE doméstico',
    ru: 'Домашний EVSE',
    vi: 'Thiết bị EVSE gia đình',
  },
  evseOperationTypeOperator: {
    zh_cn: '运营设备',
    en: 'Operating Evse',
    zhhant: '運營設備',
    he: 'EVSE הפעלה',
    de: 'Betriebs-EVSE',
    es: 'EVSE de operación',
    ru: 'Операционный EVSE',
    vi: 'Thiết bị EVSE hoạt động',
  },
  cart: {
    zh_cn: '汽车',
    en: 'Car',
    zhhant: '汽車',
    he: 'רכב',
    de: 'Fahrzeug',
    es: 'Carro',
    ru: 'Автомобиль',
    vi: 'Xe hơi',
  },
  bike: {
    zh_cn: '电单车',
    en: 'Bike',
    zhhant: '電單車',
    he: 'אופניים חשמליים',
    de: 'Fahrrad',
    es: 'Bicicleta',
    ru: 'Электровелосипед',
    vi: 'Xe đạp điện',
  },
  ac: {
    zh_cn: '交流',
    en: 'AC',
    zhhant: '交流',
    he: 'AC',
    de: 'AC',
    es: 'AC',
    ru: 'AC',
    vi: 'AC',
  },
  dc: {
    zh_cn: '直流',
    en: 'DC',
    zhhant: '直流',
    he: 'DC',
    de: 'DC',
    es: 'DC',
    ru: 'DC',
    vi: 'DC',
  },
  acdc: {
    zh_cn: '交直流一体机',
    en: 'AC And DC',
    zhhant: '交流直流一體機',
    he: 'AC ו-DC',
    de: 'AC und DC',
    es: 'AC y DC',
    ru: 'AC и DC',
    vi: 'AC và DC',
  },
  chineseStandard: {
    zh_cn: '国标',
    zhhant: '國標',
    en: 'Chinese standards',
    he: 'תקנים סיניים',
    de: 'Chinesische Standards',
    es: 'Normas chinas',
    ru: 'Китайские стандарты',
    vi: 'Tiêu chuẩn Trung Quốc',
  },
  americanStandard: {
    zh_cn: '美标',
    zhhant: '美標',
    en: 'American Standards',
    he: 'תקנים אמריקאיים',
    de: 'Amerikanische Standards',
    es: 'Normas americanas',
    ru: 'Американские стандарты',
    vi: 'Tiêu chuẩn Mỹ',
  },
  europeanStandard: {
    zh_cn: '欧标',
    zhhant: '歐標',
    en: 'European Standards',
    he: 'תקנים אירופיים',
    de: 'Europäische Standards',
    es: 'Normas europeas',
    ru: 'Европейские стандарты',
    vi: 'Tiêu chuẩn châu Âu',
  },
  onePhase: {
    zh_cn: '单相',
    zhhant: '單相',
    en: 'One Phase',
    he: 'פאזת יחיד',
    de: 'Einphasen',
    es: 'Monofásico',
    ru: 'Однофазный',
    vi: 'Một pha',
  },
  threePhase: {
    zh_cn: '三相',
    zhhant: '三相',
    en: 'Three Phase',
    he: 'תלת פאזי',
    de: 'Dreiphasen',
    es: 'Trifásico',
    ru: 'Трехфазный',
    vi: 'Ba pha',
  },
  connectorTypeAcGbt: {
    zh_cn: '交流GB/T 20234',
    zhhant: '交流GB/T 20234',
    en: 'AC GB/T 20234',
    he: 'AC GB/T 20234',
    de: 'AC GB/T 20234',
    es: 'AC GB/T 20234',
    ru: 'AC GB/T 20234',
    vi: 'AC GB/T 20234',
  },
  connectorTypeAcType1: {
    zh_cn: '交流SAE-J1772',
    zhhant: '交流SAE-J1772',
    en: 'AC SAE-J1772',
    he: 'AC SAE-J1772',
    de: 'AC SAE-J1772',
    es: 'AC SAE-J1772',
    ru: 'AC SAE-J1772',
    vi: 'AC SAE-J1772',
  },
  connectorTypeAcType2: {
    zh_cn: '交流IEC62196',
    zhhant: '交流IEC62196',
    en: 'AC IEC62196',
    he: 'AC IEC62196',
    de: 'AC IEC62196',
    es: 'AC IEC62196',
    ru: 'AC IEC62196',
    vi: 'AC IEC62196',
  },
  connectorTypeAcType1Tiny: {
    zh_cn: '交流SAE-J1772 (日本)',
    zhhant: '交流SAE-J1772 (日本)',
    en: 'AC SAE-J1772 Tiny',
    he: 'AC SAE-J1772 (יפן)',
    de: 'AC SAE-J1772 (Japan)',
    es: 'AC SAE-J1772 (Japón)',
    ru: 'AC SAE-J1772 (Япония)',
    vi: 'AC SAE-J1772 (Nhật Bản)',
  },
  connectorTypeAcNacs: {
    zh_cn: '交流NACS',
    zhhant: '交流NACS',
    en: 'AC NACS',
    he: 'AC NACS',
    de: 'AC NACS',
    es: 'AC NACS',
    ru: 'AC NACS',
    vi: 'AC NACS',
  },
  connectorTypeDcGbt: {
    zh_cn: '直流GB/T 20234',
    zhhant: '直流GB/T 20234',
    en: 'DC GB/T 20234',
    he: 'DC GB/T 20234',
    de: 'DC GB/T 20234',
    es: 'DC GB/T 20234',
    ru: 'DC GB/T 20234',
    vi: 'DC GB/T 20234',
  },
  connectorTypeDcCcs1: {
    zh_cn: '直流SAE-J1772',
    zhhant: '直流SAE-J1772',
    en: 'DC SAE-J1772',
    he: 'DC SAE-J1772',
    de: 'DC SAE-J1772',
    es: 'DC SAE-J1772',
    ru: 'DC SAE-J1772',
    vi: 'DC SAE-J1772',
  },
  connectorTypeDcCcs2: {
    zh_cn: '直流IEC62196',
    zhhant: '直流IEC62196',
    en: 'DC IEC62196',
    he: 'DC IEC62196',
    de: 'DC IEC62196',
    es: 'DC IEC62196',
    ru: 'DC IEC62196',
    vi: 'DC IEC62196',
  },
  connectorTypeDcChm: {
    zh_cn: '直流CHADEMO',
    zhhant: '直流CHADEMO',
    en: 'DC CHADEMO',
    he: 'DC CHAdeMO',
    de: 'DC CHAdeMO',
    es: 'DC CHAdeMO',
    ru: 'DC CHAdeMO',
    vi: 'DC CHAdeMO',
  },
  connectorTypeDcNacs: {
    zh_cn: '直流NACS',
    zhhant: '直流NACS',
    en: 'DC NACS',
    he: 'DC NACS',
    de: 'DC NACS',
    es: 'DC NACS',
    ru: 'DC NACS',
    vi: 'DC NACS',
  },
  connectorTypeBike: {
    zh_cn: '插口',
    zhhant: '插口',
    en: 'Connector',
    de: 'Anschluss',
    es: 'Conector',
    ru: 'Соединитель',
    vi: 'Kết nối',
  },
  createProfile: {
    zh_cn: '创建充电配置文件',
    zhhant: '創建充電配置文件',
    en: 'Create Charging Profile',
    he: 'צור פרופיל חשמל טעינה',
    de: 'Charging-Profil erstellen',
    es: 'Crear perfil de carga',
    ru: 'Создать профиль зарядки',
    vi: 'Tạo hồ sơ lập kế hoạch năng lượng',
  },
  profile: {
    zh_cn: '智能充电配置',
    zhhant: '智能充電配置',
    en: 'Smart Charging Profile',
    he: 'פרופיל חשמל טעינה',
    de: 'Smart Charging Profile',
    es: 'Perfil de carga inteligente',
    ru: 'Профиль силовой зарядки',
    vi: 'Hồ sơ lập kế hoạch năng lượng',
  },
  localAuthorizationList: {
    zh_cn: '离线授权列表',
    zhhant: '離線授權列表',
    en: 'Local Authorization List',
    he: 'רשימת אישור מקומי',
    de: 'Lokale Autorisierungsliste',
    es: 'Lista de autorización local',
    ru: 'Локальный список авторизации',
    vi: 'Danh sách phân quyền tại chỗ',
  },
  chargingProfilePurpose: {
    zh_cn: '充电配置用途',
    zhhant: '充電配置用途',
    en: 'Charging Profile Purpose',
    he: 'מטרה פרופיל חשמל טעינה',
    de: 'Verwendungszweck des Charging Profils',
    es: 'Propósito del perfil de carga',
    ru: 'Назначение профиля зарядки',
    vi: 'Mục đích hồ sơ lập kế hoạch năng lượng',
  },
  chargingProfileKind: {
    zh_cn: '充电配置类型',
    zhhant: '充電配置類型',
    en: 'Charging Profile Kind',
    he: 'סוג פרופיל חשמל טעינה',
    de: 'Art des Charging Profils',
    es: 'Tipo de perfil de carga',
    ru: 'Вид профиля зарядки',
    vi: 'Loại hồ sơ lập kế hoạch năng lượng',
  },
  recurrencyKind: {
    zh_cn: '重复类型',
    zhhant: '重複類型',
    en: 'Recurrency Kind',
    he: 'סוג חוזר',
    de: 'Wiederholungsart',
    es: 'Tipo de recurrencia',
    ru: 'Вид повторения',
    vi: 'Loại lặp lại',
  },
  stackLevel: {
    zh_cn: '堆栈等级',
    zhhant: '堆栈等級',
    en: 'Stack Level',
    he: 'רמת עיגולה',
    de: 'Stapelstufe',
    es: 'Nivel de apilamiento',
    ru: 'Уровень стека',
    vi: 'Cấp đứng',
  },
  chargingSchedule: {
    zh_cn: '充电计划',
    zhhant: '充電計劃',
    en: 'Charging Schedule',
    he: 'תזמון חשמל טעינה',
    de: 'Ladeplan',
    es: 'Programa de carga',
    ru: 'Программа зарядки',
    vi: 'Lịch lập kế hoạch năng lượng',
  },
  minChargingRate: {
    zh_cn: '最小充电速率',
    zhhant: '最小充電速率',
    en: 'Min Charging Rate',
    he: 'מקסימום חשמל טעינה',
    de: 'Mindestladerate',
    es: 'Velocidad de carga mínima',
    ru: 'Минимальная скорость зарядки',
    vi: 'Tốc độ sạc tối thiểu',
  },
  startScheduleTime: {
    zh_cn: '开始计划时间',
    zhhant: '開始計劃時間',
    en: 'Start Schedule Time',
    he: 'זמן תחילת תזמון חשמל טעינה',
    es: 'Hora de inicio del programa de carga',
    vi: 'Thời gian bắt đầu lịch lập kế hoạch năng lượng',
    ru: 'Время начала программы зарядки',
    de: 'Startzeit des Ladeplans',
  },
  duration: {
    zh_cn: '持续时间',
    zhhant: '持續時間',
    en: 'Duration',
    he: 'משך זמן',
    de: 'Dauer',
    es: 'Duración',
    ru: 'Длительность',
    vi: 'Thời lượng',
  },
  startPeriod: {
    zh_cn: '开始时段',
    zhhant: '開始時段',
    en: 'Start Period',
    he: 'תקופה תחילת תזמון חשמל טעינה',
    de: 'Startperiode',
    es: 'Período de inicio',
    ru: 'Временной период начала',
    vi: 'Điểm bắt đầu',
  },
  numberPhases: {
    zh_cn: '相位数',
    zhhant: '相數量',
    en: 'Phases',
    he: 'מספר פחות',
    de: 'Phasen',
    es: 'Fases',
    ru: 'Фазы',
    vi: 'Các cặp',
  },
  limit: {
    zh_cn: '限制',
    zhhant: '限制',
    en: 'Limit',
    he: 'גבול',
    de: 'Grenze',
    es: 'Límite',
    ru: 'Ограничение',
    vi: 'Giới hạn',
  },
  card: {
    zh_cn: '卡',
    zhhant: '卡',
    en: 'RFID Card',
    he: 'כרטיס RFID',
    de: 'RFID-Karte',
    es: 'Tarjeta RFID',
    ru: 'RFID карта',
    vi: 'Thẻ RFID',
  },
  auth: {
    zh_cn: '授权',
    zhhant: '授權',
    en: 'Authorization',
    de: 'Autorisierung',
    es: 'Autorización',
    ru: 'Авторизация',
    vi: 'Quyền hạn',
  },
  orderAuthStat: {
    zh_cn: '充电授权分布',
    zhhant: '充電授權分布',
    en: 'Session Distribution',
    he: 'פיזור אישור טעינה',
    de: 'Verteilung der Sitzungen',
    es: 'Distribución de sesiones',
    ru: 'Распределение сеансов',
    vi: 'Phân phối phiên',
  },
  electricityStat: {
    zh_cn: '充电电量',
    zhhant: '充電電量',
    en: 'Charge Electricity',
    he: 'חשמל טעינה',
    de: 'Ladeelektrizität',
    es: 'Electricidad de carga',
    ru: 'Зарядная электроэнергия',
    vi: 'Điện năng sạc',
  },
  electricityKhw: {
    zh_cn: '充电电量(度)',
    zhhant: '充電電量(度)',
    en: 'Charge Electricity(Kwh)',
    he: 'חשמל טעינה (ק"ג)',
    de: 'Ladeelektrizität(KWh)',
    es: 'Electricidad de carga(Kwh)',
    ru: 'Зарядная электроэнергия(кВтч)',
    vi: 'Điện năng sạc(Kwh)',
  },
  amountStat: {
    zh_cn: '电费金额',
    zhhant: '電費金額',
    en: 'Electricity Amount',
    he: 'חשמל טעינה',
    de: 'Ladeelektrizität',
    es: 'Electricidad de carga',
    ru: 'Зарядная электроэнергия',
    vi: 'Điện năng sạc',
  },
  Einheit: {
    zh_cn: '￥',
    zhhant: '￥',
    en: '$',
  },
  anomalyRate: {
    zh_cn: '异常率',
    zhhant: '異常率',
    en: 'Abnormality Rate',
    he: 'שיעור חריגות',
    de: 'Anomalie-Rate',
    es: 'Tasa de anomalías',
    ru: 'Уровень аномалий',
    vi: 'Tỷ lệ bất thường',
  },
  amountService: {
    zh_cn: '服务费金额',
    zhhant: '服務費金額',
    en: 'Service fee amount',
    he: 'שיעור חריגות',
    de: 'Anomalie-Rate',
    es: 'Tasa de anomalías',
    ru: 'Уровень аномалий',
    vi: 'Tỷ lệ bất thường',
  },
  recover: {
    zh_cn: '恢复类型',
    zhhant: '恢復類型',
    en: 'Recover',
    he: 'שחזור',
    de: 'Wiederherstellen',
    es: 'Recuperar',
    ru: 'Восстановление',
    vi: 'Khôi phục',
  },
  action: {
    zh_cn: '激活中',
    zhhant: '啟動中',
    en: 'Actions',
    he: 'פעולות',
    de: 'Aktionen',
    es: 'Acciones',
    ru: 'Действия',
    vi: 'Hành động',
  },
  close: {
    zh_cn: '关闭',
    zhhant: '關閉',
    en: 'Close',
    he: 'סגור',
    de: 'Schließen',
    es: 'Cerrar',
    ru: 'Закрыть',
    vi: 'Đóng',
  },
  addAlarmRepository: {
    zh_cn: '添加报警仓库',
    zhhant: '新增警報倉庫',
    en: 'Add Alarm Repository',
    he: 'הוסף אזור אשראי',
    de: 'Alarm-Repository hinzufügen',
    es: 'Agregar repositorio de alarmas',
    ru: 'Добавить репозиторий предупреждений',
    vi: 'Thêm kho cảnh báo',
  },
  editAlarmRepository: {
    zh_cn: '编辑报警仓库',
    zhhant: '編輯警報倉庫',
    en: 'Edit Alarm Repository',
    he: 'ערוך אזור אשראי',
    de: 'Alarm-Repository bearbeiten',
    es: 'Editar repositorio de alarmas',
    ru: 'Редактировать репозиторий предупреждений',
    vi: 'Sửa kho cảnh báo',
  },
  alarmCode: {
    zh_cn: '报警代码',
    zhhant: '警報代碼',
    en: 'Alarm Code',
    he: 'קוד אזור',
    de: 'Alarm-Code',
    es: 'Código de alarma',
    ru: 'Код предупреждения',
    vi: 'Mã cảnh báo',
  },
  subAlarmCode: {
    zh_cn: '子报警代码',
    zhhant: '子警報代碼',
    en: 'Sub-Alarm Code',
    he: 'קוד אזור משנה',
    de: 'Unteralarm-Code',
    es: 'Código de subalarma',
    ru: 'Подчиненный код предупреждения',
    vi: 'Mã cảnh báo phụ',
  },
  alarmRecoverAuto: {
    zh_cn: '自动恢复',
    zhhant: '自動恢復',
    en: 'Auto-Recovery',
    he: 'שחזור אוטומטי',
    de: 'Automatische Wiederherstellung',
    es: 'Recuperación automática',
    ru: 'Автоматическое восстановление',
    vi: 'Khôi phục tự động',
  },
  alarmRecoverManul: {
    zh_cn: '人工恢复',
    zhhant: '人工恢復',
    en: 'Manual-Recovery',
    he: 'שחזור ידני',
    de: 'Manuelle Wiederherstellung',
    es: 'Recuperación manual',
    ru: 'Ручное восстановление',
    vi: 'Khôi phục thủ công',
  },
  alarmRecoverOps: {
    zh_cn: '运维恢复',
    zhhant: '運維恢復',
    en: 'Ops-Recovery',
    he: 'שחזור תפעולי',
    de: 'Betriebswiederherstellung',
    es: 'Recuperación operativa',
    ru: 'Операционное восстановление',
    vi: 'Khôi phục vận hành',
  },
  alarmLevel: {
    zh_cn: '告警级别',
    zhhant: '警報等級',
    en: 'Alarm Level',
    he: 'רמת כשלה',
    de: 'Fehlerstufe',
    es: 'Nivel de alarma',
    ru: 'Уровень предупреждения',
    vi: 'Cấp cảnh báo',
  },
  alarmName: {
    zh_cn: '告警名称',
    zhhant: '警報名稱',
    en: 'Alarm Name',
    he: 'שם כשלה',
    de: 'Fehlername',
    es: 'Nombre de alarma',
    ru: 'Имя предупреждения',
    vi: 'Tên cảnh báo',
  },
  alarmType: {
    zh_cn: '告警类型',
    zhhant: '警報類型',
    en: 'Alarm Type',
    he: 'סוג כשלה',
    de: 'Fehlerart',
    es: 'Tipo de alarma',
    ru: 'Тип сбоя',
    vi: 'Loại cảnh báo',
  },
  alarmTypeInterval: {
    zh_cn: '间隙故障',
    zhhant: '間隙故障',
    en: 'Interval',
    he: 'כשל בין',
    de: 'Intervallfehler',
    es: 'Fallo de intervalo',
    ru: 'Интервальный сбой',
    vi: 'Lỗi khoảng cách',
  },
  alarmTypeBurst: {
    zh_cn: '突变-信号故障',
    zhhant: '突變-信號故障',
    en: 'Burst',
    he: 'כשל התפרצות',
    de: 'Burst-Fehler',
    es: 'Fallo de ráfaga',
    ru: 'Всплесковый сбой',
    vi: 'Lỗi bùng nổ',
  },
  alarmTypeGradual: {
    zh_cn: '缓变故障',
    zhhant: '緩變故障',
    en: 'Gradual',
    he: 'כשל הדרגתי',
    de: 'Allmählicher Fehler',
    es: 'Fallo gradual',
    ru: 'Постепенный сбой',
    vi: 'Lỗi dần dần',
  },
  alarmTypeComponent: {
    zh_cn: '元器件故障',
    zhhant: '元件故障',
    en: 'Component',
    he: 'כשל רכיב',
    de: 'Bauteilfehler',
    es: 'Fallo de componente',
    ru: 'Сбой компонента',
    vi: 'Lỗi linh kiện',
  },
  alarmLevelCommon: {
    zh_cn: '普通',
    zhhant: '普通',
    en: 'Common',
    he: 'נפוץ',
    de: 'Gemein',
    es: 'Común',
    ru: 'Обычный',
    vi: 'Thông thường',
  },
  alarmLevelMinor: {
    zh_cn: '次要',
    zhhant: '次要',
    en: 'Minor',
    he: 'קטן',
    de: 'Geringfügig',
    es: 'Menor',
    ru: 'Незначительный',
    vi: 'Nhỏ',
  },
  alarmLevelImportant: {
    zh_cn: '重要',
    zhhant: '重要',
    en: 'Important',
    he: 'חשוב',
    de: 'Wichtig',
    es: 'Importante',
    ru: 'Важный',
    vi: 'Quan trọng',
  },
  alarmLevelCrash: {
    zh_cn: '紧急',
    zhhant: '緊急',
    en: 'Crash',
    he: 'קריסה',
    de: 'Kollaps',
    es: 'Crítico',
    ru: 'Критический',
    vi: 'Khẩn cấp',
  },
  operational: {
    zh_cn: '设备运营',
    zhhant: '設備運營',
    en: 'Operational',
    he: 'פעיל',
    de: 'Betriebsfähig',
    es: 'Operativo',
    ru: 'Работоспособный',
    vi: 'Hoạt động',
  },
  nonOperational: {
    zh_cn: '设备下架',
    zhhant: '設備下架',
    en: 'Non-operational',
    he: 'לא פעיל',
    de: 'Nicht betriebsfähig',
    es: 'No operativo',
    ru: 'Неисправный',
    vi: 'Không hoạt động',
  },
  loadbalance: {
    zh_cn: '负载均衡',
    zhhant: '負載均衡',
    en: 'Load Balance',
    he: 'איזון עומס',
    de: 'Lastenausgleich',
    es: 'Equilibrio de carga',
    ru: 'Балансировка нагрузки',
    vi: 'Cân bằng tải',
  },
  otaState: {
    zh_cn: 'OTA状态',
    zhhant: 'OTA狀態',
    en: 'OTA State',
    he: 'מצב OTA',
    de: 'OTA-Status',
    es: 'Estado de OTA',
    ru: 'Состояние OTA',
    vi: 'Trạng thái OTA',
  },
  latestChargingSchedule: {
    zh_cn: '最近充电计划',
    zhhant: '最近充電計劃',
    en: 'Recent Charging Schedule',
    he: 'לוח זמנים אחרון לטעינה',
    de: 'Letzter Ladeplan',
    es: 'Horario de Carga Reciente',
    ru: 'Последнее расписание зарядки',
    vi: 'Lịch sạc gần đây',
  },
  selectSmartCharging: {
    zh_cn: '选择智能充电方式',
    zhhant: '選擇智慧充電方式',
    en: 'Select smart charging mode',
    he: 'בחר מצב הזמנה',
    de: 'Intelligentes Laden auswählen',
    es: 'Seleccionar modo de carga inteligente',
    ru: 'Выберите интеллектуальный режим зарядки',
    vi: 'Chọn chế độ năng lượng thông minh',
  },
  disableSmartCharging: {
    zh_cn: '停用智能充电',
    zhhant: '停用智慧充電',
    en: 'disable smart charging',
    he: 'הפסק הזמנה',
    de: 'Intelligentes Laden deaktivieren',
    es: 'Deshabilitar carga inteligente',
    ru: 'Отключить интеллектуальную зарядку',
    vi: 'Tắt năng lượng thông minh',
  },
  smartChargingAVG: {
    zh_cn: '平均充电',
    zhhant: '平均充電',
    en: 'Average charging',
    he: 'ממוצע הזמנה',
    de: 'Durchschnittlich laden',
    es: 'Carga media',
    ru: 'Среднее зарядка',
    vi: 'Lập lịch ưu tiên năng lượng',
  },
  smartChargingFCFS: {
    zh_cn: '有序充电',
    zhhant: '有序充電',
    en: 'First come, first served',
    he: 'אחרי הזמנה',
    de: 'Zuerst eingetroffen, zuerst ausgeladen',
    es: 'Primero en, primero servido',
    ru: 'Первые входят, первыми выходят',
    vi: 'Lập lịch ưu tiên năng lượng',
  },
  missingMaxLoad: {
    zh_cn: '缺少最大功率和最大电流录入',
    zhhant: '缺少最大功率和最大电流录入',
    en: 'Missing maximum load info',
    he: 'שגיאה בכניסת מיקום',
    de: 'Fehlende Einstellung für maximale Leistung und Spannung',
    es: 'Falta información de carga máxima',
    ru: 'Отсутствует информация о максимальной нагрузке',
    vi: 'Thiếu thông tin tối đa năng lượng',
  },
  evseProtocol: {
    zh_cn: '充电协议',
    zhhant: '充電協議',
    en: 'Charging Protocol',
    he: 'פרוטוקול הזמנה',
    de: 'Ladeprotokoll',
    es: 'Protocolo de carga',
    ru: 'Протокол зарядки',
    vi: 'Giao thức sạc',
  },
  EPV_CD: {
    zh_cn: '橙电协议',
    zhhant: '橙電協議',
    en: 'Orange Protocol',
    he: 'EPV_CD',
    de: 'EPV_CD',
    es: 'EPV_CD',
    ru: 'EPV_CD',
    vi: 'EPV_CD',
  },
  EPV_QINGAN: {
    zh_cn: 'QINGAN',
    zhhant: 'QINGAN',
    en: 'QINGAN',
    he: 'QINGAN',
    de: 'QINGAN',
    es: 'QINGAN',
    ru: 'QINGAN',
    vi: 'QINGAN',
  },
  EPV_SUNGROW: {
    zh_cn: 'SUNGROW',
    zhhant: 'SUNGROW',
    en: 'SUNGROW',
    he: 'SUNGROW',
    de: 'SUNGROW',
    es: 'SUNGROW',
    ru: 'SUNGROW',
    vi: 'SUNGROW',
  },
  homeProto: {
    zh_cn: '家用协议',
    zhhant: '家用協議',
    en: 'Home Protocol',
    he: 'פרוטוקול בית',
    de: 'Heimprotokoll',
    es: 'Protocolo de casa',
    ru: 'Домашний протокол',
    vi: 'Giao thức nhà',
  },
  ocpp: {
    zh_cn: 'OCPP',
    zhhant: 'OCPP',
    en: 'OCPP',
    he: 'OCPP',
    de: 'OCPP',
    es: 'OCPP',
    ru: 'OCPP',
    vi: 'OCPP',
  },
  ykc: {
    zh_cn: 'YKC',
    zhhant: 'YKC',
    en: 'YKC',
    he: 'YKC',
    de: 'YKC',
    es: 'YKC',
    ru: 'YKC',
    vi: 'YKC',
  },
  hkc: {
    zh_cn: 'HKC',
    zhhant: 'HKC',
    en: 'HKC',
    he: 'HKC',
    de: 'HKC',
    es: 'HKC',
    ru: 'HKC',
    vi: 'HKC',
  },
  goiot: {
    zh_cn: 'GOIOT',
    zhhant: 'GOIOT',
    en: 'GOIOT',
    he: 'GOIOT',
    de: 'GOIOT',
    es: 'GOIOT',
    ru: 'GOIOT',
    vi: 'GOIOT',
  },
  sinexcel: {
    zh_cn: 'SINEXCEL',
    zhhant: 'SINEXCEL',
    en: 'SINEXCEL',
    he: 'SINEXCEL',
    de: 'SINEXCEL',
    es: 'SINEXCEL',
    ru: 'SINEXCEL',
    vi: 'SINEXCEL',
  },
  szunit: {
    zh_cn: 'SZUNIT',
    zhhant: 'SZUNIT',
    en: 'SZUNIT',
    he: 'SZUNIT',
    de: 'SZUNIT',
    es: 'SZUNIT',
    ru: 'SZUNIT',
    vi: 'SZUNIT',
  },

  function: {
    zh_cn: '功能',
    zhhant: '功能',
    en: 'Function',
    he: 'פונקציה',
    de: 'Funktion',
    es: 'Funcion',
    ru: 'Функция',
    vi: 'Chức năng',
  },
  functionTips: {
    zh_cn: '提示: 设备功能最终以设备上报为主。后台修改后,有可能被设备覆盖.',
    zhhant: '提示: 设备功能最终以设备上报为主。后台修改后,有可能被设备覆盖.',
    en: 'Tips: The final function of the device is reported by the device. After modification in the background, it may be overridden by the device.',
    he: 'הודעה: פונקציה של המכשיר סופית מדווחת על ידי המכשיר. אם יש שינויים ברשימת פונקציות שנשמרו ברשת, ייתכן שתהיה מעבר על פונקציה שנשמרה בצד שרת.',
    de: 'Hinweis: Die endgültige Funktion des Geräts wird von diesem Gerät gemeldet. Nach Änderungen in der Liste der Funktionen, die auf dem Server gespeichert sind, kann es sein, dass eine Funktion, die auf dem Server gespeichert ist, nicht mehr funktioniert.',
    es: 'Nota: La función final del dispositivo se informa de este dispositivo. Si hay cambios en la lista de funciones que se almacenan en la red, es posible que la función que se almacena en la red no funcione.',
    ru: 'Примечание: окончательная функция устройства сообщается этим устройством. При изменении в списке функций, сохраненных на сервере, может быть невозможно использовать предыдущую версию приложения.',
    vi: 'Lưu ý: Chức năng cuối cùng của thiết bị được báo cáo bởi thiết bị. Sau khi sửa đổi trên nền, có thể sẽ bị thiết bị ghi đè.',
  },
  funcSectionPirce: {
    zh_cn: '分段计费',
    zhhant: '分段計費',
    en: 'Section Price',
    he: 'פונקציה מחיר',
    de: 'Preisberechnung',
    es: 'Precio de la sección',
    ru: 'Размер платы',
    vi: 'Phân đoạn tính phí',
  },
  funcScheduleCharge: {
    zh_cn: '定时充电',
    zhhant: '定時充電',
    en: 'Schedule Charge',
    he: 'פונקציה הזמנה',
    de: 'Zeitgesteuerte Ladeplanung',
    es: 'Planificación de carga programada',
    ru: 'Запланированная зарядка',
    vi: 'Lịch sạc',
  },
  funcReserverCharge: {
    zh_cn: '预约充电',
    zhhant: '預約充電',
    en: 'Reserver Charge',
    he: 'פונקציה הזמנה',
    de: 'Zeitgesteuerte Ladeplanung',
    es: 'Planificación de carga programada',
    ru: 'Запланированная зарядка',
    vi: 'Lịch sạc',
  },
  funcOfflineCharge: {
    zh_cn: '离线充电',
    zhhant: '离线充电',
    en: 'Offline Charge',
    he: 'פונקציה הזמנה',
    de: 'Zeitgesteuerte Ladeplanung',
    es: 'Planificación de carga programada',
    ru: 'Запланированная зарядка',
    vi: 'Lịch sạc',
  },
  funcSyncAli0: {
    zh_cn: '同步蚂蚁链-重模式',
    zhhant: '同步蚂蚁链-重模式',
    en: 'Sync Ali-Heavy Mode',
    he: 'פונקציה הזמנה',
    de: 'Zeitgesteuerte Ladeplanung',
    es: 'Planificación de carga programada',
    ru: 'Запланированная зарядка',
    vi: 'Lịch sạc',
  },
  funcSyncAli1: {
    zh_cn: '同步蚂蚁链-轻模式',
    zhhant: '同步蚂蚁链-轻模式',
    en: 'Sync Ali-Light Mode',
    he: 'פונקציה הזמנה',
    de: 'Zeitgesteuerte Ladeplanung',
    es: 'Planificación de carga programada',
    ru: 'Запланированная зарядка',
    vi: 'Lịch sạc',
  },
  funcBT: {
    zh_cn: '蓝牙充电',
    zhhant: '藍牙充電',
    en: 'Bluetooth Charge',
    he: 'פונקציה הזמנה',
    de: 'Zeitgesteuerte Ladeplanung',
    es: 'Planificación de carga programada',
    ru: 'Запланированная зарядка',
    vi: 'Lịch sạc',
  },
  funcBtNoSense: {
    zh_cn: '无感蓝牙充电',
    zhhant: '無感藍牙充電',
    en: 'Bluetooth Charge',
    he: 'פונקציה הזמנה',
    de: 'Zeitgesteuerte Ladeplanung',
    es: 'Planificación de carga programada',
    ru: 'Запланированная зарядка',
    vi: 'Lịch sạc',
  },
  funcGetTariff: {
    zh_cn: '获取计费模版',
    zhhant: '獲取計費模版',
    en: 'Get tariff template',
    he: 'פונקציה הזמנה',
    de: 'Zeitgesteuerte Ladeplanung',
    es: 'Planificación de carga programada',
    ru: 'Запланированная зарядка',
    vi: 'Lịch sạc',
  },
  funcElecThreeDecimals: {
    zh_cn: '电量三位小数',
    zhhant: '電量三位小數',
    en: 'Electricity three decimals',
    he: 'פונקציה הזמנה',
    de: 'Zeitgesteuerte Ladeplanung',
    es: 'Planificación de carga programada',
    ru: 'Запланированная зарядка',
    vi: 'Lịch sạc',
  },
  selectQrCodeList: {
    zh_cn: '请勾选需要下载二维码的列表',
    zhhant: '請勾選需要下載二維碼的列表',
    en: 'Please select the list to download QR codes',
    he: 'אנא בחר את הרשימה להורדת קודי QR',
    de: 'Bitte wählen Sie die Liste aus, um QR-Codes herunterzuladen',
    es: 'Seleccione la lista para descargar códigos QR',
    ru: 'Пожалуйста, выберите список для загрузки QR-кодов',
    vi: 'Vui lòng chọn danh sách để tải xuống mã QR',
  },
  evseStationNatureSN_EVSE: {
    zh_cn: '充电',
    en: 'Charging',
    zhhant: '充電',
    he: 'טעינה',
    de: 'Laden',
    es: 'Carga',
    ru: 'Зарядка',
    vi: 'Sạc',
  },
  evseStationNatureSN_ESS: {
    zh_cn: '储能',
    en: 'Energy Storage',
    zhhant: '儲能',
    he: 'אגירת אנרגיה',
    de: 'Energiespeicher',
    es: 'Almacenamiento de energía',
    ru: 'Накопление энергии',
    vi: 'Lưu trữ năng lượng',
  },
  evseStationNatureSN_PVES: {
    zh_cn: '光伏',
    en: 'Photovoltaic',
    zhhant: '光伏',
    he: 'פוטו-וולטאי',
    de: 'Photovoltaik',
    es: 'Fotovoltaica',
    ru: 'Фотовольтаика',
    vi: 'Quang điện',
  },
  deviceType: {
    zh_cn: '设备子类型 ',
    en: 'Device Subtype',
    zhhant: '設備子類型',
    he: 'סוג משנה של מכשיר',
    de: 'Geräteuntertyp',
    es: 'Subtipo de dispositivo',
    ru: 'Подтип устройства',
    vi: 'Loại phụ thiết bị',
  },
  pvCapacity: {
    zh_cn: '装机容量kWp',
    zhhant: '裝機容量kWp',
    en: 'Installed Capacity (kWp)',
    he: 'קיבולת מותקנת (kWp)',
    de: 'Installierte Kapazität (kWp)',
    es: 'Capacidad instalada (kWp)',
    ru: 'Установленная мощность (kWp)',
    vi: 'Công suất lắp đặt (kWp)',
  },

  ECS_FAST: {
    zh_cn: '快充',
    zhhant: '快充',
    en: 'Fast Charging',
    he: 'טעינה מהירה',
    de: 'Schnellladung',
    es: 'Carga rápida',
    ru: 'Быстрая зарядка',
    vi: 'Sạc nhanh',
  },

  ECS_SLOW: {
    zh_cn: '慢充',
    zhhant: '慢充',
    en: 'Slow Charging',
    he: 'טעינה איטית',
    de: 'Langsames Laden',
    es: 'Carga lenta',
    ru: 'Медленная зарядка',
    vi: 'Sạc chậm',
  },
  speedType: {
    zh_cn: '充电速度',
    zhhant: '充電速度',
    en: 'Charging Speed',
    de: 'Ladegeschwindigkeit',
    es: 'Velocidad de carga',
    he: 'מהירות טעינה',
    ru: 'Скорость зарядки',
    vi: 'Tốc độ sạc',
  },
  lockState: {
    zh_cn: '车位锁状态',
    zhhant: '车位鎖狀態',
    en: 'Parking Lock State',
    he: 'מצב נעילת חניה',
    de: 'Status der Parkierungssperre',
    es: 'Estado de bloqueo de aparcamiento',
    ru: 'Состояние блокировки стоянки',
    vi: 'Trạng thái khóa chỗ đậu'
  },
  parkingVehicleState: {
    zh_cn: '是否有车',
    zhhant: '是否有车',
    en: 'Parking Vehicle State',
    he: 'מצב כלי רכב',
    de: 'Status des Parkfahrzeugs',
    es: 'Estado del vehículo de estacionamiento',
    ru: 'Состояние автомобиля на стоянке',
    vi: "Trạng thái xe"
  },
  lastActivityTime: {
    zh_cn: '最后活跃时间',
    zhhant: '最后活跃时间',
    en: 'Last Activity Time',
    he: 'זמן הפעילות אחרון',
    de: 'Letzte Aktivitätszeit',
    es: 'Hora de la última actividad',
    ru: 'Время последней активности',
    vi: "Thời điểm hoạt động cuối cùng"
  },
  notParked: {
    zh_cn: '无车',
    zhhant: '无车',
    en: 'Not Parked',
    he: 'לא חניה',
    de: 'Nicht geparkt',
    es: 'No estacionado',
    ru: 'Не на стоянке',
    vi: "Không có xe"
  },
  alreadyParked: {
    zh_cn: '有车',
    zhhant: '有车',
    en: 'Already Parked',
    he: 'יש חניה',
    de: 'Bereits geparkt',
    es: 'Ya estacionado',
    ru: 'На стоянке',
    vi: "Đã đậu"
  },
  riseLock: {
    zh_cn: '升锁',
    zhhant: '升锁',
    en: 'Rise Lock',
    he: 'העלת אבטחה',
    de: 'Hochschloss',
    es: 'Subir el candado',
    ru: 'Поднять замок',
    vi: "Tăng khóa"
  },
  fallLock: {
    zh_cn: '降锁',
    zhhant: '降锁',
    en: 'Lower Lock',
    he: 'הורדת אבטחה',
    de: 'Runterschloss',
    es: 'Bajar el candado',
    ru: 'Опустить замок',
    vi: "Giảm khóa"
  },
  parkingLockRise: {
    zh_cn: '已上升',
    zhhant: '已上升',
    en: 'Rise',
    he: 'עלייה',
    de: 'Aufstieg',
    es: 'Subir',
    ru: 'Поднять',
    vi: 'Tăng'
  },
  parkingLockRising: {
    zh_cn: '上升中',
    zhhant: '上升中',
    en: 'Rising',
    he: 'עולה',
    de: 'Steigend',
    es: 'Subiendo',
    ru: 'Подъем',
    vi: "Tăng"
  },
  parkingLockFall: {
    zh_cn: "已下降",
    zhhant: "已下降",
    en: "Fall",
    he: "הורדה",
    de: "Fall",
    es: "Caída",
    ru: "Падение",
    vi: "Giảm"
  },
  parkingLockFalling: {
    zh_cn: "下降中",
    zhhant: "下降中",
    en: "Falling",
    he: "מורד",
    de: "Fallen",
    es: "Descendiendo",
    ru: "Падение",
    vi: "Giảm"
  },
  parkingLockStopped: {
    zh_cn: "下降、上升中停止",
    zhhant: "下降、上升中停止",
    en: "Stopped",
    he: "נעצר",
    de: "Gestoppt",
    es: "Detenido",
    ru: "Остановлено",
    vi: "Dừng"
  },

  lastBootTime: {
    zh_cn: '上次离线时间',
    zhhant: '上次離線時間',
    en: 'Last Offline Time',
    he: 'זמן היעדרות אחרון',
    de: 'Letzte Offline-Zeit',
    es: 'Último tiempo de desconexión',
    ru: 'Последнее время отключения',
    vi: 'Thời gian offline cuối cùng',
  },
  lastDisconnectReason: {
    zh_cn: '离线原因',
    zhhant: '離線原因',
    en: 'Offline Reason',
    he: 'סיבה להיעדרות',
    de: 'Offline-Grund',
    es: 'Razón de la desconexión',
    ru: 'Причина отключения',
    vi: 'Lý do offline',
  },
  evseInfo: {
    zh_cn: '设备信息',
    zhhant: '設備信息',
    en: 'Device Information',
    he: 'מידע על המכשיר',
    de: 'Geräteinformationen',
    es: 'Información del dispositivo',
    ru: 'Информация об устройстве',
    vi: 'Thông tin thiết bị',
  },
  deleteEssDeviceConfirm: {
    zh_cn: '警告！该操作将会删除此光伏设备',
    zhhant: '警告！該操作將會刪除此光伏設備',
    en: 'Warning! This operation will delete this PV device',
    he: 'אזהרה! פעולה זו תמחק את המכשיר הפוטו-וולטאי',
    de: 'Warnung! Dieser Vorgang löscht das PV-Gerät',
    es: '¡Advertencia! Esta operación eliminará el dispositivo de fotovoltaica',
    ru: 'Предупреждение! Эта операция удалит фотоэлектрическое устройство',
    vi: 'Cảnh báo! Thao tác này sẽ xóa thiết bị PV',
  },
  deletePLockConfirm: {
    zh_cn: '删除后数据不可恢复，确定删除地锁设备？ ',
    zhhant: '刪除後數據不可恢復，確定刪除地鎖設備？ ',
    en: 'Data cannot be recovered after deletion. Are you sure to delete the parking lock device?',
    he: 'לא ניתן לשחזר נתונים לאחר מחיקה. האם אתה בטוח שברצונך למחוק את המכשיר של אבטחת החניה?',
    de: 'Daten können nach dem Löschen nicht wiederhergestellt werden. Möchten Sie das Parksperren-Gerät wirklich löschen?',
    es: 'Los datos no se pueden recuperar después de la eliminación. ¿Está seguro de que desea eliminar el dispositivo de bloqueo de estacionamiento?',
    ru: 'Данные не могут быть восстановлены после удаления. Вы действительно хотите удалить устройство блокировки стоянки?',
    vi: 'Dữ liệu không thể khôi phục sau khi xóa. Bạn có chắc chắn muốn xóa thiết bị khóa xe?',
  },
  rebootPlockConfirm: {
    zh_cn: '确认重启地锁设备?',
    zhhant: '確認重啟地鎖設備?',
    en: 'Confirm to reboot the parking lock device?',
    he: 'אשר להפעיל מחדש את מכשיר אבטחת החניה?',
    de: 'Möchten Sie das Parksperren-Gerät neu starten?',
    es: '¿Confirmar para reiniciar el dispositivo de bloqueo de estacionamiento?',
    ru: 'Подтвердить перезагрузку устройства блокировки стоянки?',
    vi: 'Xác nhận khởi động lại thiết bị khóa xe?',
  },
  resetPlockConfirm: {
    zh_cn: '重置将清除所有配置，确定重置?',
    zhhant: '重置將清除所有配置，確定重置?',
    en: 'Reset will clear all configurations. Are you sure to reset?',
    he: 'איפוס ימחק את כל ההגדרות. האם אתה בטוח שברצונך לאפס?',
    de: 'Zurücksetzen löscht alle Konfigurationen. Möchten Sie wirklich zurücksetzen?',
    es: 'El restablecimiento borrará todas las configuraciones. ¿Está seguro de que desea restablecer?',
    vi: 'Đặt lại sẽ xóa tất cả các cấu hình. Bạn có chắc chắn muốn đặt lại?',
    ru: 'Сброс удалит все конфигурации. Вы действительно хотите сбросить?',
  },
  plockClearAlarm: {
    zh_cn: '清除报警',
    zhhant: '清除報警',
    en: 'Clear Alarm',
    he: 'מחק התראה',
    de: 'Alarm löschen',
    es: 'Borrar alarma',
    ru: 'Очистить тревогу',
    vi: 'Xóa báo động'
  },
  alarm: {
    zh_cn: '报警',
    zhhant: '報警',
    en: 'Alarm',
    he: 'תראה',
    de: 'Alarm',
    es: 'Alarma',
    ru: 'Тревога',
    vi: 'Báo động'
  },
}
